(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseBookingRateOptionComparison',
	};

	var checkedCategories = {};

	var mr_ineligible_msg = 'The rate code or cabin category that you have selected is not eligible with the Flex Membership Rewards promotion. If you wish to continue, your client will not receive any MR points for this booking. Press "Yes" to continue or "No" to cancel';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.category-radio').click(function doSelectRateOptionCabinCategory(e) {
			selectRateOptionCabinCategory($(this).data("i") + '-' + $(this).data("j"));
			if (!$(this).hasClass('cruise-sheet')) {
				handleMrIneligibleSelected($(this));
			}
			e.stopPropagation();
		});

		$('.category-checkbox').click(function doCheckCategory(e) {
			checkCategory($(this).data("i") + '-' + $(this).data("j"), $(this).data("code"));
			selectRateOptionCabinCategory($(this).data("i") + '-' + $(this).data("j"));
			if (!$(this).hasClass('cruise-sheet')) {
				handleMrIneligibleSelected($(this));
			}
			e.stopPropagation();

			if ($(this).hasClass('cruise-sheet')) {
				limitCategorySelection(this);
			}
		});

		$('.rate-option-comparison .category-selection').click(function cellClicked(e) {
			var code        = $(this).data('code'),
				category_id = code.replace("|", "-");

			// $('.category-checkbox').each(function uncheckOtherBoxes() {
			// 	$(this).prop('checked', false);
			// });

			$('.category-checkbox').each(function setChecked() {
				if ($(this).val() === code) {
					$(this).prop('checked', true);
				}
			});

			if ($('#upgrade-' + category_id)) {
				$('#upgrade-' + category_id).prop('checked', true);
			}
		});

		// $('.category-checkbox').click(function checkboxClicked() {
		// 	var code        = $(this).val(),
		// 		category_id = code.replace("|", "-");

		// 	$('.category-checkbox').each(function uncheckOtherBoxes() {
		// 		$(this).prop('checked', false);
		// 	});

		// 	$(this).prop('checked', true);

		// 	if ($('#upgrade-' + category_id)) {
		// 		$('#upgrade-' + category_id).prop('checked', true);
		// 	}
		// });

		$('.create-reservation').click(function click(e) {
			$('#cruisebookingrateoptioncomparison-action').val('create_reservation');

			$(form.element).submit();
		});
	};

	form.submit = function submit()
	{
		validate();
	};

	// function selectOption(number)
	// {
	// 	if ($('#rateOptionCabinCategory' + number).prop('checked') === false) {
	// 		$('#rateOptionCabinCategory' + number).prop('checked', true);
	// 	} else {
	// 		$('#rateOptionCabinCategory' + number).prop('checked', false);
	// 	}

	// 	selectRateOptionCabinCategory(number);

	// 	return;
	// }

	function selectRateOptionCabinCategory(number)
	{
/*
		var i;
		var j;

		j = 0;

		for (i = 0; $('#rateOptionCabinCategory' + i + '-' + j); i++) {
			for (j = 0; $('#rateOptionCabinCategory' + i + '-' + j); j++) {
				if ($('#rateOptionCabinCategoryUpgrade' + i + '-' + j)) {
					$('#rateOptionCabinCategoryUpgrade' + i + '-' + j).prop('checked', false);
					$('#rateOptionCabinCategoryUpgrade' + i + '-' + j).prop('disabled', true);
				}
			}

			j = 0;
		}

		// if ($('#categoryTotalButton')) {
		// 	$('#categoryTotalButton').value = 'View Category Totals';
		// }

		if ($('#rateOptionCabinCategory' + number).prop('checked') === true) {
			if ($('#rateOptionCabinCategoryUpgrade' + number)) {
				$('#rateOptionCabinCategoryUpgrade' + number).prop('disabled', false);
				$('#rateOptionCabinCategoryUpgrade' + number).prop('checked', true);
			}

			// if ($('#categoryTotalButton')) {
			// 	var valChunks = $('#rateOptionCabinCategory' + number).value.split(/\|/);

			// 	$('#categoryTotalButton').value = 'View ' + valChunks[1] + ' Category Totals';
			// }
		}
*/
		return;
	}

	function checkCategory(number, code)
	{
		if (code in checkedCategories && number !== checkedCategories[code]) {
			$('#rateOptionCabinCategory' + checkedCategories[code]).checked = false;
		}

		checkedCategories[code] = number;

		return;
	}

	function validate()
	{
		var i;
		var j;
		var rateOptionCabinCategorySelected = false;

		j = 0;

		for (i = 0; $('#rateOptionCabinCategory' + i + '-' + j); i++) {
			for (j = 0; $('#rateOptionCabinCategory' + i + '-' + j); j++) {
				if ($('#rateOptionCabinCategory' + i + '-' + j).prop('checked', true)) {
					rateOptionCabinCategorySelected = true;

					break;
				}
			}

			j = 0;
		}

		if (!rateOptionCabinCategorySelected) {
			alert('You must select a cabin category in order to continue.');

			return false;
		}

		return true;
	}

	function limitCategorySelection(input)
	{
		var $input = $(input);

		if ($('.category-checkbox.cruise-sheet:checked').length > 10) {
			$input.prop('checked', false);

			Adzuki.StatusMessage(null, 'You can only select up to 10 rate option / category combinations for live pricing', 'Max reached');
		}
	}

	function handleMrIneligibleSelected(checkbox)
	{
		var mr_eligible;
		var option_mr_eligible;

		mr_eligible        = checkbox.data('mr-eligible');
		option_mr_eligible = checkbox.data('option-mr-eligible');

		if (
			mr_eligible !== undefined
			&& option_mr_eligible !== undefined
			&& parseInt(mr_eligible) === 1
			&& parseInt(option_mr_eligible) === 0
		) {
			form.confirm_message       = mr_ineligible_msg;
			form.confirm_before_submit = true;
		} else {
			form.confirm_message       = '';
			form.confirm_before_submit = false;
		}
	}
}(jQuery, window.Adzuki || {}));
